<template>
  <div>
    <u-error-handling
      v-if="errorObject"
      :error-object="errorObject"
      class="mt-4"
    />
    <v-btn
      class="btn-left mt-4 mb-4"
      color="success"
      raised
      title="Speichern"
      @click="saveWageSupplementDayOfHour"
    >
      <i class="fas fa-save mr-3" /> Speichern
    </v-btn>

    <u-loader v-if="isLoading" />

    <div v-else>
      <h5 class="mt-5">
        Tag von Stunde
      </h5>

      <div
        v-for="(dayOfFromHour, dayOfFromHourIndex) in dayOfFromHours"
        :key="dayOfFromHourIndex"
        class="mt-5 mb-4"
      >
        <wage-supplement-day-of-hour-capture
          :wage-supplement-day-of-hour-conf="dayOfFromHour"
          :wage-supplement-types="dayOfFromHourTypes"
          contents-field="wageSupplementTermConfigurationContents"
          text-field="text"
          type-field="dayOfFromHour"
          @inputContent="updateDayFromHourContent($event, dayOfFromHourIndex)"
        />
        <hr class="mt-5">
      </div>

      <h5 class="mt-5">
        Tag bis Stunde
      </h5>

      <div
        v-for="(dayOfToHour, dayOfToHourIndex) in dayOfToHours"
        :key="dayOfToHourIndex + 100"
        class="mt-5 mb-4"
      >
        <wage-supplement-day-of-hour-capture
          :wage-supplement-day-of-hour-conf="dayOfToHour"
          :wage-supplement-types="dayOfToHourTypes"
          contents-field="wageSupplementTermConfigurationContents"
          text-field="text"
          type-field="dayOfToHour"
          @inputContent="updateDayToHourContent($event, dayOfToHourIndex)"
        />
        <hr class="mt-5">
      </div>

      <h5 class="mt-5">
        Sommer- und Winterzeit
      </h5>

      <div
        v-for="(seasonalTime, seasonalTimeIndex) in seasonalTimes"
        :key="seasonalTimeIndex + 200"
        class="mt-5 mb-4"
      >
        <wage-supplement-day-of-hour-capture
          :wage-supplement-day-of-hour-conf="seasonalTime"
          :wage-supplement-types="seasonalTimeTypes"
          contents-field="wageSupplementTermConfigurationContents"
          text-field="text"
          type-field="seasonalTime"
          @inputContent="updateSeasonalTimeContent($event, seasonalTimeIndex)"
        />
        <hr class="mt-5">
      </div>

      <h5 class="mt-5">
        Aktuelles-/ Folgejahr
      </h5>

      <div
        v-for="(toCompensateYear, toCompensateYearIndex) in toCompensateYears"
        :key="toCompensateYearIndex + 300"
        class="mt-5 mb-4"
      >
        <wage-supplement-day-of-hour-capture
          :wage-supplement-day-of-hour-conf="toCompensateYear"
          :wage-supplement-types="toCompensateYearTypes"
          contents-field="wageSupplementTermConfigurationContents"
          text-field="text"
          type-field="compensateYear"
          @inputContent="
            updateToCompensateYearContent($event, toCompensateYearIndex)
          "
        />
        <hr class="mt-5">
      </div>

      <h5 class="mt-5">
        Anwendbare Tage
      </h5>

      <div
        v-for="(applicableDaysConf, applicableDaysIndex) in applicableDays"
        :key="applicableDaysIndex + 400"
        class="mt-5 mb-4"
      >
        <wage-supplement-day-of-hour-capture
          :wage-supplement-day-of-hour-conf="applicableDaysConf"
          :wage-supplement-types="applicableDaysTypes"
          contents-field="wageSupplementTermConfigurationContents"
          text-field="text"
          type-field="applicableDays"
          @inputContent="updateApplicableDaysContent($event, applicableDaysIndex)"
        />
        <hr class="mt-5">
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetWageSupplementTerms,
  SaveWageSupplementTerms,
  GetWageSupplementDayoffromhourTypes,
  GetWageSupplementToCompensateYearTypes,
  GetWageSupplementDayoftohourTypes,
} from "@/services/wageSupplement.wageSupplementTerms.service";
import wageSupplementDayOfHourCapture from "@/components/wageSupplement/WageSupplement.DayOfHour.Capture.vue";
import {
  GetSeasonalTimeTypes,
  GetApplicableDaysTypes,
} from "../../services/minimum.wage.services/zuschlagsrechner/definition";

export default {
  components: { wageSupplementDayOfHourCapture },
  data() {
    return {
      dayOfFromHours: [],
      dayOfToHours: [],
      seasonalTimes: [],
      toCompensateYears: [],
      applicableDays: [],
      dayOfFromHourTypes: {},
      dayOfToHourTypes: {},
      seasonalTimeTypes: {},
      toCompensateYearTypes: {},
      applicableDaysTypes: {},
      isLoading: false,
      errorObject: null,
    };
  },

  created() {
    this.loadDayOfHourTypes();
  },
  methods: {
    updateDayFromHourContent(content, index) {
      this.dayOfFromHours[index].wageSupplementTermConfigurationContents =
        content;
    },

    updateDayToHourContent(content, index) {
      this.dayOfToHours[index].wageSupplementTermConfigurationContents =
        content;
    },

    updateSeasonalTimeContent(content, index) {
      this.seasonalTimes[index].wageSupplementTermConfigurationContents =
        content;
    },

    updateToCompensateYearContent(content, index) {
      this.toCompensateYears[index].wageSupplementTermConfigurationContents =
        content;
    },

    updateApplicableDaysContent(content, index) {
      this.applicableDays[index].wageSupplementTermConfigurationContents =
        content;
    },

    async loadDayOfHourTypes() {
      this.isLoading = true;
      try {
        // Parallel laden von "from" und "to" HourTypes
        const [
          dayOfFromHourTypes,
          dayOfToHourTypes,
          seasonalTimeTypes,
          toCompensateYearTypes,
          applicableDaysTypes,
        ] = await Promise.all([
          new Promise((resolve, reject) => {
            GetWageSupplementDayoffromhourTypes(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
          new Promise((resolve, reject) => {
            GetWageSupplementDayoftohourTypes(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
          new Promise((resolve, reject) => {
            GetSeasonalTimeTypes(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
          new Promise((resolve, reject) => {
            GetWageSupplementToCompensateYearTypes(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
          new Promise((resolve, reject) => {
            GetApplicableDaysTypes(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
        ]);

        // Setzen der Ergebnisse
        this.dayOfFromHourTypes = dayOfFromHourTypes;
        this.dayOfToHourTypes = dayOfToHourTypes;
        this.seasonalTimeTypes = seasonalTimeTypes;
        this.toCompensateYearTypes = toCompensateYearTypes;
        this.applicableDaysTypes = applicableDaysTypes;

        // Weiter laden der "from" und "to" Hours
        await this.loadDayOfHour();

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        this.errorObject = error;
      }
    },

    async loadDayOfHour() {
      try {
        // Parallel laden von "from" und "to" Hours
        const [terms] = await Promise.all([
          new Promise((resolve, reject) => {
            GetWageSupplementTerms(
              (response) => resolve(response),
              (error) => reject(error),
            );
          }),
        ]);

        // Setzen der Ergebnisse
        this.dayOfFromHours = terms.filter((x) => x.dayOfFromHour);
        this.dayOfToHours = terms.filter((x) => x.dayOfToHour);
        this.seasonalTimes = terms.filter((x) => x.seasonalTime);
        this.toCompensateYears = terms.filter((x) => x.compensateYear);
        this.applicableDays = terms.filter((x) => x.applicableDays);
      } catch (error) {
        this.errorObject = error;
        this.isLoading = false;
      }
    },

    saveWageSupplementDayOfHour() {
      this.isLoading = true;

      const termPromise = new Promise((resolve, reject) => {
        SaveWageSupplementTerms(
          [
            ...this.dayOfFromHours,
            ...this.dayOfToHours,
            ...this.seasonalTimes,
            ...this.toCompensateYears,
            ...this.applicableDays,
          ],
          () => resolve(),
          (error) => reject(error),
        );
      });

      Promise.all([termPromise])
        .then(() => {
          // Nach erfolgreichem Speichern beide Stundenkonfigurationen neu laden
          return this.loadDayOfHour();
        })
        .then(() => {
          // Ladevorgang nach dem Laden der Stundenkonfigurationen beenden
          this.isLoading = false;
        })
        .catch((error) => {
          // Fehlerbehandlung und Laden beenden
          this.errorObject = error;
          this.isLoading = false;
        });
    },
  },
};
</script>

<style scoped></style>
